module.exports = __webpack_public_path__ + "img/flower_leaf_24.fd465478.png";